import { FaStickyNote } from "react-icons/fa";
import { StickyNotesViewMain } from "../Components/StickyNotesViewMain";

export const StickyNotesModule = () => [
    {
        views: "PRIVATE", path: "/sticky-notes", component: <StickyNotesViewMain />,
        roles: null, permissions: null, label: "Notas rápidas", icon: <FaStickyNote />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: true,
        isBlockedWhenLogged: false,
    },
];
